import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { getToken, getHciToken } from '@/utils/auth'
import { isObject } from '@/utils'
// const defaultSettings = require('../../cfg/defaults');
// const url = process.env.NODE_ENV === 'development' ? defaultSettings.dev.baseAPIUrl : defaultSettings.build.baseAPIUrl
// const baseApiUrl = window.location.protocol + '//' + window.location.hostname

const service = axios.create({
  baseURL: '/',
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

service.interceptors.request.use(config => {
  // console.log(config)
  if(!config.multi){
    config.data = qs.stringify(config.data)
  }
  
  if (!config.baseURL.includes('check-video') && getToken()) {
    config.headers.Token = getToken()
    config.headers['HCI-TOKEN'] = getHciToken()
  }

  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {

    if(!isObject(response.data) || response.data.code <= 0){
      return Promise.reject(response.data)
    }
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    if (typeof error.msg != 'undefined'){
      Message({
        message: error.msg || '网络延迟，请刷新！',
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js